import { Injectable } from '@angular/core';
import { PIP_MASTER_STATES_LIST } from '../../config/constants';

/**
 * Service to manage playground mode state selection and testing functionality.
 * Stores which states are selected for testing PIP workflows without affecting normal app flow.
 */
@Injectable({
  providedIn: 'root',
})
export class PlaygroundService {
  private playgroundPIPStates: string[] | null = null;
  private playgroundUMStates: string[] | null = null;

  setPlaygroundPIPStates(selectedStates: string[]): void {
    this.playgroundPIPStates = selectedStates;
  }

  setPlaygroundUMStates(selectedStates: string[]): void {
    this.playgroundUMStates = selectedStates;
  }

  clearPlaygroundPIPStates(): void {
    this.playgroundPIPStates = null;
  }

  clearPlaygroundUMStates(): void {
    this.playgroundUMStates = null;
  }

  isPlaygroundMode(): boolean {
    return (
      this.playgroundPIPStates !== null && this.playgroundPIPStates.length > 0
    );
  }

  isPlaygroundUMMode(): boolean {
    return (
      this.playgroundUMStates !== null && this.playgroundUMStates.length > 0
    );
  }

  getPlaygroundPIPStates(): string[] | null {
    return this.playgroundPIPStates;
  }

  getPlaygroundUMStates(): string[] | null {
    return this.playgroundUMStates;
  }
  /**
   * Returns state names formatted for component selectors and file paths
   * Converts "North Carolina" to "north-carolina" format
   */
  getPlaygroundCoveredPIPStates(): string[] {
    if (!this.playgroundPIPStates || this.playgroundPIPStates.length === 0) {
      return [];
    }

    const formattedStates = this.playgroundPIPStates.map((state) =>
      state.toLowerCase().replace(/\s+/g, '-'),
    );
    return formattedStates;
  }

  getPlaygroundCoveredUMStates(): string[] {
    if (!this.playgroundUMStates || this.playgroundUMStates.length === 0) {
      return [];
    }
    const formattedStates = this.playgroundUMStates.map((state) =>
      state.toLowerCase().replace(/\s+/g, '-'),
    );
    return formattedStates;
  }

  resetPlayground(): void {
    this.clearPlaygroundPIPStates();
  }

  resetPlaygroundUM(): void {
    this.clearPlaygroundUMStates();
  }
}
